import {
  AGIcon,
  ClosedMenuArrow,
  FillAGIcon,
  FillHubIcon,
  FillOrderIcon,
  FillOrgIcon,
  FillPGIcon,
  FillPSPIcon,
  FillProdIcon,
  FillTeamIcon,
  HubIcon,
  OpenMenuArrow,
  OrderIcon,
  OrgIcon,
  PGIcon,
  PSPIcon,
  ProdIcon,
  PspFillIcon,
  PspIcon,
  SettingsFillIcon,
  SettingsIcon,
  TeamIcon,
} from "../../assets/images/svg/svg";

export const menuItems = [
  {
    icon: <HubIcon />,
    fillIcon: <FillHubIcon />,
    name: "Hub",
    code: "HUB",
    path: "/hub",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Information",
        path: "/hub/information",
        code: "HUB1",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Dashboard",
        path: "/hub/dashboard",
        code: "HUB2",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Reports",
        path: "/hub/reports",
        code: "HUB3",
        access_flag: 1,
      },
    ],
  },
  {
    icon: <OrgIcon />,
    fillIcon: <FillOrgIcon />,
    name: "Org",
    code: "ORG",
    path: "/org",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Information",
        path: "/org/organization",
        code: "HUB1",
        access_flag: 1,
      },
    ],
  },
  {
    icon: <TeamIcon />,
    fillIcon: <FillTeamIcon />,
    name: "Team",
    code: "SETTINGS",
    path: "/settings/user_management/users",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Users",
        path: "/settings/user_management/users",
        code: "SETT_MST",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Role",
        path: "/settings/user_management/roles",
        code: "SETT_UMT",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Access",
        path: "/settings/user_management/module_access",
        code: "SETT_UTL",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Group",
        path: "/settings/user_management/group",
        code: "SETT_UTL",
        access_flag: 1,
      },
    ],
  },
  {
    icon: <ProdIcon />,
    fillIcon: <FillProdIcon />,
    name: "Prod",
    code: "PROD",
    path: "/prod",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Product",
        path: "/prod/product",
        code: "AG1",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Product Variant",
        path: "/prod/product_variant",
        code: "AG1",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Clubbed Product",
        path: "/prod/clubbed_product",
        code: "AG1",
        access_flag: 1,
      },
    ],
  },
  {
    icon: <PGIcon />,
    fillIcon: <FillPGIcon />,
    name: "PG",
    code: "PG",
    path: "/pg",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Payment Gateway",
        path: "/pg/payment_gateway",
        code: "PG1",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Merchant",
        path: "/pg/merchant",
        code: "PG1",
        access_flag: 1,
      },
    ],
  },
  {
    icon: <PSPIcon />,
    fillIcon: <FillPSPIcon />,
    name: "PSP",
    code: "PSP",
    path: "/psp",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Product/Service Provider",
        path: "/psp/psp",
        code: "AG1",
        access_flag: 1,
      },
    ],
  },
  {
    icon: <AGIcon />,
    fillIcon: <FillAGIcon />,
    name: "AG",
    code: "AG",
    path: "/ag/ag",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Affinity Group",
        path: "/ag/ag",
        code: "AG1",
        access_flag: 1,
      },
    ],
  },
  {
    icon: <OrderIcon />,
    fillIcon: <FillOrderIcon />,
    name: "Order",
    code: "ORD",
    path: "/order",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Order",
        path: "/ag/affinity_group",
        code: "ORD1",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "SubOrder",
        path: "/ag/affinity_group",
        code: "ORD2",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Transactions",
        path: "/ag/affinity_group",
        code: "ORD3",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Refunds",
        path: "/ag/affinity_group",
        code: "ORD4",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Claims",
        path: "/ag/affinity_group",
        code: "ORD5",
        access_flag: 1,
      },

    ],
  },


  {
    icon: <SettingsIcon />,
    fillIcon: <SettingsFillIcon />,
    name: "Settings",
    code: "SETN",
    path: "/settings",
    access_flag: 1,
    menus: [
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "IP Whitelisting",
        path: "/settings/ipwhitelisting",
        code: "SETN_IPWL",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Qualification",
        path: "/settings/qualification",
        code: "SETN_QUAL",
        access_flag: 1,
      },
      {
        iconOpened: <OpenMenuArrow />,
        iconClosed: <ClosedMenuArrow />,
        menu_name: "Bulk Order",
        path: "/settings/bulkorder",
        code: "SETN_BULK",
        access_flag: 1,
      },
    ],
  },
];
